var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 0H16.5509V2.06786H18.6188V0Z",
    fill: " "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3107 0H37.2402V2.06786H39.3107V0Z",
    fill: " "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4464 0H41.3786V2.06786H43.4464V0Z",
    fill: " "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 6.20625H33.1045V8.27679H35.1723V4.13839H33.1045V2.06786H35.1723V0H31.0339V2.06786H28.9661V4.13839H31.0339V6.20625Z",
    fill: " "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3107 8.27679H41.3786V6.20625H43.4491V4.13839H39.3107V8.27679Z",
    fill: " "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 10.3446V4.13839H4.13839V10.3446H10.3446Z",
    fill: " "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 8.27679H35.1723V10.3446H37.2402V8.27679Z",
    fill: " "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 12.4125V14.483H22.7598V12.4125H24.8277V14.483H26.8955V12.4125H28.9661V10.3446H31.0339V12.4125H33.1045V14.483H35.1723V10.3446L33.1045 10.3446L33.1045 8.27679H28.9661V4.13839H26.8955V2.06786H22.7598V0H20.6893V2.06786H18.6214V4.13839H20.6893V6.20625H16.5509V8.27679H24.8277V6.20625H26.8955V10.3446H16.5509V14.483H18.6214V12.4125H20.6893Z",
    fill: " "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 14.483V0H0V14.483H14.483ZM2.06786 2.06786H12.4125V12.4125H2.06786V2.06786Z",
    fill: " "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 16.5509V18.6214H14.483V16.5509H10.3446Z",
    fill: " "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 18.6214V16.5509H22.7598V18.6214H26.8955Z",
    fill: " "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 16.5509V12.4125H28.9661V18.6214H31.0339V22.7598H33.1045V18.6214H35.1723V20.6893H37.2402V16.5509H43.4491V12.4125H41.3786V14.483H39.3107V12.4125H37.2402V14.483L35.1723 14.483V16.5509H31.0339Z",
    fill: " "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 18.6214H49.6554V16.5509H47.5875V18.6214Z",
    fill: " "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7938 18.6214V16.5509H51.7232V18.6214H53.7938Z",
    fill: " "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16.5509H57.9321V18.6188H60V16.5509Z",
    fill: " "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3786 18.6214H39.3107V20.6893H41.3786V18.6214Z",
    fill: " "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4491 20.6893H45.517V16.5509H43.4491V20.6893Z",
    fill: " "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 18.6214H0V22.7598H2.06786V18.6214Z",
    fill: " "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27679 20.6893V18.6214H6.20625V22.7598H10.3446V20.6893H8.27679Z",
    fill: " "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6214 22.7598V20.6893H20.6893V14.483H18.6214V16.5509H16.5509V18.6214H14.483V20.6893H12.4152V22.7598H18.6214Z",
    fill: " "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 20.6893H24.8277V22.7571H26.8955V20.6893Z",
    fill: " "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 20.6893H45.517L45.517 22.7571H47.5848V20.6893Z",
    fill: " "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 20.6893H53.7938V22.7571H55.8616V20.6893Z",
    fill: " "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 22.7598H10.3446V24.8277H12.4125V22.7598Z",
    fill: " "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1723 22.7598H33.1045L33.1045 24.8277H35.1723V22.7598Z",
    fill: " "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 28.9661H41.3786V24.8277H45.517V22.7598H43.4491V20.6893H41.3786V22.7598H39.3107L39.3107 20.6893H37.2402V28.9661Z",
    fill: " "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 24.8277V26.8955H51.7232V20.6893H49.6554V22.7598H47.5875V24.8277H49.6554Z",
    fill: " "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 24.8277H12.4152V26.8955H14.483V24.8277Z",
    fill: " "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 24.8277V20.6893H20.6893V24.8277H16.5509V26.8955H26.8955V24.8277H22.7598Z",
    fill: " "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 24.8277H45.517L45.517 26.8955H43.4491V28.9661H45.517V31.0339H43.4491V33.1045H41.3786V31.0339H39.3107V35.1723H37.2402V37.2402H35.1723V39.3107H39.3107V41.3786H41.3786V39.3107H43.4491V37.2402H41.3786V35.1723H45.517V33.1045H47.5875V28.9661H49.6554V26.8955H47.5875V24.8277Z",
    fill: " "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 24.8277H53.7938V26.8955H55.8616V24.8277Z",
    fill: " "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 28.9661H18.6214V31.0339H16.5509V33.1045H20.6893V28.9661Z",
    fill: " "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8277 28.9661H22.7598V33.1045H24.8277V28.9661Z",
    fill: " "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4464 28.9661H41.3786V31.0339L43.4464 31.0339V28.9661Z",
    fill: " "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13839 28.9661H6.20625V33.1045H8.27679V31.0339L16.5509 31.0339V28.9661H12.4152L12.4152 26.8955H6.20625V24.8277H4.13839V26.8955H0V28.9661H2.06786V33.1045H4.13839V28.9661Z",
    fill: " "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 33.1045H51.7232V35.1723H53.7938V28.9661L49.6554 28.9661V33.1045Z",
    fill: " "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9295 31.0339H55.8616V33.1018H57.9295V31.0339Z",
    fill: " "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 33.1045H0V35.1723H2.06786L2.06786 33.1045Z",
    fill: " "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 33.1045H8.27679V35.1723H10.3446V33.1045Z",
    fill: " "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 33.1045H12.4152V35.1723H14.483V33.1045Z",
    fill: " "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 37.2402H22.7598V33.1045H20.6893V37.2402Z",
    fill: " "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9661 35.1723H31.0339V39.3107H33.1045V37.2402H35.1723V33.1045H37.2402V31.0339H35.1723V26.8955H33.1045V24.8277H31.0339L31.0339 22.7598H26.8955V24.8277H28.9661V26.8955H31.0339V31.0339H33.1045V33.1045H31.0339V31.0339H26.8955V33.1045H28.9661V35.1723Z",
    fill: " "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 33.1045L47.5875 33.1045V35.1723H49.6554V33.1045Z",
    fill: " "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 0H47.5875V2.06786H49.6554V0Z",
    fill: " "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7911 0H51.7232V2.06786H53.7911V0Z",
    fill: " "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 4.13839H45.517V6.20625H47.5848V4.13839Z",
    fill: " "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 4.13839H53.7938V6.20625H55.8616V4.13839Z",
    fill: " "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 10.3446H51.7232V4.13839H49.6554V6.20625H47.5875V8.27679H49.6554V10.3446Z",
    fill: " "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 8.27679H53.7938V10.3446H55.8616V8.27679Z",
    fill: " "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 12.4152H49.6554L49.6554 10.3446H47.5875V8.27679H45.517L45.517 16.5509H47.5875V12.4152Z",
    fill: " "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 35.1723H45.517V37.2402H47.5848V35.1723Z",
    fill: " "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 37.2402L6.20625 33.1045H4.13839L4.13839 35.1723H2.06786V37.2402H0V41.3786H2.06786V39.3107H10.3446V37.2402H6.20625Z",
    fill: " "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6214 37.2402H16.5509V35.1723L14.483 35.1723V37.2402H12.4152V39.3107H16.5509V41.3786H18.6214V37.2402Z",
    fill: " "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7232 39.3107V37.2402H47.5875V39.3107H51.7232Z",
    fill: " "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 39.3107L10.3446 39.3107V41.3786H12.4125V39.3107Z",
    fill: " "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9661 35.1723L26.8955 35.1723V33.1045L24.8277 33.1045V37.2402H26.8955V43.4491H28.9661V35.1723Z",
    fill: " "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9321 39.3107L51.7232 39.3107V41.3786H55.8616V43.4491H53.7938V45.517H57.9321V43.4491H60V41.3786H57.9321V39.3107Z",
    fill: " "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 41.3786H4.13839V43.4464H6.20625V41.3786Z",
    fill: " "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 43.4491V41.3786H24.8277V39.3107H20.6893V41.3786H18.6214V43.4491H22.7598Z",
    fill: " "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 43.4491H16.5509V45.517H18.6188V43.4491Z",
    fill: " "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 45.517H18.6214V47.5848H20.6893V45.517Z",
    fill: " "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 45.517H45.517V47.5848H47.5848V45.517Z",
    fill: " "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M60 45.517H57.9321V47.5848H60V45.517Z",
    fill: " "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 47.5875H16.5509V49.6554H18.6188V47.5875Z",
    fill: " "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9634 47.5875H26.8955V49.6554H28.9634V47.5875Z",
    fill: " "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 49.6554H53.7938V45.517H51.7259V41.3786H41.3813V47.5848H37.2429V45.517H39.3134V43.4491H37.2429V41.3813H31.0366V43.4491H28.9688V47.5875H31.0366V45.5196H35.175V49.658H37.2429V53.7964H39.3134V51.7286H49.658V53.7964H53.7964V51.7286H60.0027V49.6607H57.9348V47.5929H55.867V49.6607L55.8616 49.6554ZM49.6554 49.6554H43.4491V43.4491H49.6554V49.6554Z",
    fill: " "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 51.7232V53.7938H35.1723V51.7232H33.1045V49.6554H28.9661V51.7232H31.0339Z",
    fill: " "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 53.7938V55.8616H28.9661V60H31.0339V57.9321H35.1723V55.8616H31.0339L31.0339 53.7938H26.8955Z",
    fill: " "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 55.8616H45.517V53.7938H41.3786V55.8616H43.4491V60H45.517V57.9321H51.7232V55.8616H49.6554V53.7938H47.5875V55.8616Z",
    fill: " "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8277 57.9321V60H26.8955V55.8616H22.7598V53.7938H26.8955V51.7232H22.7598V49.6554H24.8277V47.5875H26.8955V43.4491H24.8277V45.517H22.7598V47.5875H20.6893V51.7232H18.6214V53.7938H16.5509V55.8616H18.6214V53.7938H20.6893V57.9321H24.8277Z",
    fill: " "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57.9321V55.8616H55.8616V57.9321H60Z",
    fill: " "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 57.9321H18.6214V60H20.6893V57.9321Z",
    fill: " "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 60V62.0679H39.3107V60H41.3786V55.8616H37.2402V57.9321L35.1723 57.9321V60H37.2402Z",
    fill: " "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 60L55.8616 57.9321L51.7232 57.9321V60H55.8616Z",
    fill: " "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9321 64.1384V62.0679H60V60H55.8616L55.8616 62.0679H53.7938V64.1384H57.9321Z",
    fill: " "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 64.1384H45.517V66.2062H47.5848V64.1384Z",
    fill: " "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64.1384H57.9321V66.2062H60V64.1384Z",
    fill: " "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 74.483H45.517V72.4152H43.4491V72.4125H41.3786V74.483H39.3107V72.4125H37.2402V74.483H35.1723V76.5509H31.0339V72.4125H28.9661V78.6214H31.0339V82.7598H33.1045V78.6214H35.1723V80.6893H37.2402V76.5509H43.4491V80.6893H45.517V76.5509H47.5875V78.6214H49.6554V76.5509H51.7232V78.6214H55.8616V76.5509H51.7232V74.483H49.6554V72.4152H47.5875V74.483Z",
    fill: " "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3107 0H97.2402V2.06786H99.3107V0Z",
    fill: " "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M103.446 0H101.379V2.06786H103.446V0Z",
    fill: " "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 6.20625H93.1045V8.27679H95.1723V4.13839H93.1045V2.06786H95.1723V0H91.0339V2.06786H88.9661V4.13839H91.0339V6.20625Z",
    fill: " "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3107 8.27679H101.379V6.20625H103.449V4.13839H99.3107V8.27679Z",
    fill: " "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2402 8.27679H95.1723V10.3446H97.2402V8.27679Z",
    fill: " "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M103.446 8.27679H101.379V10.3446H103.446V8.27679Z",
    fill: " "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 8.27679H105.517V10.3446H107.585V8.27679Z",
    fill: " "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 12.4125V14.483H82.7598V12.4125H84.8277V14.483H86.8955V12.4125H88.9661V10.3446H91.0339V12.4125H93.1045V14.483H95.1723V10.3446L93.1045 10.3446V8.27679H88.9661L88.9661 4.13839H86.8955V2.06786H82.7598V0H80.6893V2.06786H78.6214V4.13839H80.6893V6.20625H76.5509V4.13839H74.483V2.06786H78.6214V0H72.4152V2.06786H70.3446V4.13839H72.4152V6.20625H74.483V8.27679H82.7598V4.13839H84.8277V6.20625H86.8955V10.3446H74.483V8.27679H70.3446V4.13839H68.2768V2.06786H64.1384V0H62.0705V2.06786H60V4.13839H62.0705V6.20625H57.9321V8.27679H64.1384V4.13839H66.2063V6.20625H68.2768V10.3446H57.9321V14.483H60V12.4125H62.0705V14.483H64.1384V12.4125H66.2063V14.483H68.2768V12.4125H70.3446V10.3446H72.4152V12.4125H74.483V14.483H78.6214V12.4125H80.6893Z",
    fill: " "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H57.9321V2.06786L60 2.06786V0Z",
    fill: " "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 12.4125L70.3446 12.4125V14.4804H72.4125V12.4125Z",
    fill: " "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 4.13839H107.588V6.20625H109.655V4.13839Z",
    fill: " "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 16.5509V18.6214H74.483V16.5509H70.3446Z",
    fill: " "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8955 18.6214V16.5509H82.7598V18.6214H86.8955Z",
    fill: " "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 16.5509L91.0339 12.4125H88.9661L88.9661 18.6214H91.0339V22.7598H93.1045V18.6214H95.1723V20.6893H97.2402V16.5509H103.449V12.4125H101.379V14.483H99.3107V12.4125H97.2402V14.483L95.1723 14.483V16.5509H91.0339Z",
    fill: " "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M120 16.5509H117.932V18.6188H120V16.5509Z",
    fill: " "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M101.379 18.6214H99.3107V20.6893H101.379V18.6214Z",
    fill: " "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M103.449 20.6893H105.517V16.5509H103.449V20.6893Z",
    fill: " "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0679 22.7598V18.6214H60V20.6893H57.9321V22.7598H62.0679Z",
    fill: " "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2768 20.6893V18.6214H66.2063V22.7598H70.3446V20.6893H68.2768Z",
    fill: " "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6214 22.7598V20.6893H80.6893L80.6893 14.483H78.6214L78.6214 16.5509H76.5509V18.6214H74.483L74.483 20.6893H72.4152V22.7598H78.6214Z",
    fill: " "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8955 20.6893H84.8277V22.7571H86.8955V20.6893Z",
    fill: " "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 20.6893H105.517V22.7571H107.585V20.6893Z",
    fill: " "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 20.6893H113.794V22.7571H115.862V20.6893Z",
    fill: " "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M117.932 20.6893V22.7598H122.068V18.6214H120V20.6893H117.932Z",
    fill: " "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 22.7598H70.3446V24.8277H72.4125V22.7598Z",
    fill: " "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1723 22.7598H93.1045V24.8277H95.1723V22.7598Z",
    fill: " "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2402 28.9661H101.379V24.8277H105.517V22.7598H103.449V20.6893H101.379L101.379 22.7598H99.3107L99.3107 20.6893H97.2402L97.2402 28.9661Z",
    fill: " "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 24.8277V26.8955H111.723V20.6893H109.655V22.7598H107.588V24.8277H109.655Z",
    fill: " "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 24.8277H72.4152V26.8955H74.483V24.8277Z",
    fill: " "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7598 24.8277V20.6893H80.6893L80.6893 24.8277H76.5509V26.8955H86.8955V24.8277H82.7598Z",
    fill: " "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M107.588 24.8277H105.517L105.517 26.8955H103.449V28.9661H105.517V31.0339H103.449V33.1045H101.379V31.0339H99.3107V35.1723H97.2402V37.2402H95.1723V39.3107H99.3107V41.3786H101.379V39.3107H103.449V37.2402H101.379V35.1723H105.517V33.1045H107.587V28.9661H109.655V26.8955H107.587L107.588 24.8277Z",
    fill: " "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 24.8277H113.794V26.8955H115.862V24.8277Z",
    fill: " "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 28.9661H78.6214V31.0339H76.5509V33.1045H80.6893V28.9661Z",
    fill: " "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8277 28.9661H82.7598V33.1045H84.8277V28.9661Z",
    fill: " "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M103.446 28.9661H101.379L101.379 31.0339L103.446 31.0339V28.9661Z",
    fill: " "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4152 28.9661V26.8955H66.2062V24.8277H64.1384V26.8955H60V24.8277H57.9321V26.8955H55.8616V28.9661H57.9321V31.0339H60V28.9661H62.0679V33.1045H64.1384V28.9661H66.2062V33.1045H68.2768V31.0339L76.5509 31.0339V28.9661H72.4152Z",
    fill: " "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 33.1045H111.723V35.1723H113.794V28.9661L109.655 28.9661V33.1045Z",
    fill: " "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M117.929 31.0339H115.862V33.1018H117.929V31.0339Z",
    fill: " "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0679 33.1045H60V35.1723H62.0679V33.1045Z",
    fill: " "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 33.1045H68.2768L68.2768 35.1723H70.3446V33.1045Z",
    fill: " "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 33.1045H72.4152V35.1723H74.483V33.1045Z",
    fill: " "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 37.2402H82.7598L82.7598 33.1045H80.6893V37.2402Z",
    fill: " "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 39.3107H93.1045V37.2402H95.1723L95.1723 33.1045H97.2402V31.0339H95.1723V26.8955H93.1045V24.8277H91.0339L91.0339 22.7598H86.8955V24.8277H88.9661V26.8955H91.0339V31.0339H93.1045V33.1045H91.0339V31.0339H86.8955V33.1045H88.9661V35.1723H91.0339V39.3107Z",
    fill: " "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 33.1045L107.587 33.1045L107.588 35.1723H109.655V33.1045Z",
    fill: " "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 35.1723H105.517V37.2402H107.585V35.1723Z",
    fill: " "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1384 35.1723H62.0679V37.2402H60V41.3786L62.0679 41.3786V39.3107H70.3446V37.2402H66.2063L66.2062 33.1045H64.1384V35.1723Z",
    fill: " "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5509 39.3107V41.3786H78.6214V37.2402H76.5509V35.1723L74.483 35.1723V37.2402H72.4152V39.3107H76.5509Z",
    fill: " "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M111.723 39.3107V37.2402H107.588V39.3107H111.723Z",
    fill: " "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 39.3107L70.3446 39.3107V41.3786H72.4125V39.3107Z",
    fill: " "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 41.3786V43.4491H113.794V45.517H117.932V43.4491H120V41.3786H117.932V39.3107L111.723 39.3107V41.3786H115.862Z",
    fill: " "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2062 41.3786H64.1384V43.4464H66.2062V41.3786Z",
    fill: " "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9661 35.1723L86.8955 35.1723V33.1045L84.8277 33.1045L84.8277 37.2402H86.8955V43.4491H88.9661V35.1723Z",
    fill: " "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M120 45.517H117.932L117.932 47.5848H120V45.517Z",
    fill: " "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9634 47.5875H86.8955V49.6554H88.9634V47.5875Z",
    fill: " "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 51.7232V53.7938H95.1723V51.7232H93.1045V49.6554H88.9661V51.7232H91.0339Z",
    fill: " "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8277 53.7938H86.8955V51.7232H84.8277V47.5875H86.8955V43.4491H84.8277V45.517H82.7598V47.5875H80.6893V51.7232H78.6214V53.7938H80.6893V57.9321H84.8277V60H86.8955V55.8616H84.8277V53.7938Z",
    fill: " "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 55.8616L91.0339 53.7938H86.8955V55.8616H88.9661V60H91.0339V57.9321H95.1723V55.8616H91.0339Z",
    fill: " "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2402 55.8616V57.9321L95.1723 57.9321L95.1723 60H101.379V55.8616H97.2402Z",
    fill: " "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 55.8616V53.7938H107.587V55.8616H105.517V53.7938H101.379V55.8616H103.449V60H105.517V57.9321H111.723V55.8616H109.655Z",
    fill: " "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 57.9321H78.6214V60H80.6893V57.9321Z",
    fill: " "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0679 43.4491L60 43.4491V45.517L62.0679 45.517V43.4491Z",
    fill: " "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1357 45.517L62.0679 45.517V47.5848H64.1357V45.517Z",
    fill: " "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2741 43.4464V45.517H66.2062V47.5848H64.1384V51.7232H62.0679V53.7911H64.1384V57.9295H68.2741V60H72.4125V55.8616H66.2062V49.6554H68.2741V47.5848H70.3446V43.4464H68.2741Z",
    fill: " "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0679 47.5875H60V49.6554H62.0679V47.5875Z",
    fill: " "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 51.7232H68.2768V53.7911H70.3446V51.7232Z",
    fill: " "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1357 57.9321H62.0679V60H64.1357V57.9321Z",
    fill: " "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5509 43.4464V49.6554H74.483V41.3786H72.4125V47.5848H70.3446V51.7232H78.6188V49.6554H78.6214V47.5848H80.6893V45.517H78.6214V43.4491H82.7598V41.3786H84.8277V39.3107H80.6893V41.3786H78.6214L78.6214 43.4464H76.5509Z",
    fill: " "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 60H76.5509V57.9321H78.6214L78.6214 55.8616H76.5509V53.7938H72.4152V55.8616H74.483V60Z",
    fill: " "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M111.723 57.9321V60H115.862V57.9321H111.723Z",
    fill: " "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M180 14.483V0H165.517V14.483H180ZM167.587 2.06786H177.932V12.4125H167.587V2.06786Z",
    fill: " "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 10.3446V4.13839H169.655V10.3446H175.862Z",
    fill: " "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 0V2.06786H138.621V0H134.483Z",
    fill: " "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M159.311 0H157.24V2.06786H159.311V0Z",
    fill: " "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M163.446 0H161.379V2.06786H163.446V0Z",
    fill: " "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 6.20625H153.104V8.27679H155.172V4.13839H153.104V2.06786H155.172V0H151.034V2.06786H148.966V4.13839H151.034V6.20625Z",
    fill: " "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M159.311 8.27679H161.379V6.20625H163.449V4.13839H159.311V8.27679Z",
    fill: " "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 8.27679H155.172V10.3446H157.24V8.27679Z",
    fill: " "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M111.723 0H107.585V2.06786H111.723V0Z",
    fill: " "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M132.415 0H130.345V2.06786H132.415V0Z",
    fill: " "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M124.138 6.20625H126.206V8.27679H128.277V4.13839H126.206V2.06786H128.277V0H124.138V2.06786H122.068V4.13839H124.138V6.20625Z",
    fill: " "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 8.27679H128.277V10.3446H130.345V8.27679Z",
    fill: " "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M113.794 4.13839V6.20625L109.655 6.20625L109.655 8.27411H117.929V6.20625H120V10.3446H109.655V12.4125H107.585V18.6188H109.655V14.483H111.723V12.4125H113.794V14.483H115.862V12.4125H117.929V14.483H120V12.4125H122.068V10.3446H124.138V12.4125H126.206V14.483H128.274V10.3446H126.206V8.27411H122.068L122.068 4.13839H120V2.06786H115.862V0H113.794V2.06786L111.723 2.06786V4.13839H113.794Z",
    fill: " "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 16.5509H124.138V12.4125H122.068L122.068 16.5509Z",
    fill: " "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M111.723 14.483L111.723 18.6214H113.794V14.483H111.723Z",
    fill: " "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 18.6214V16.5509H142.76V18.6214H146.896Z",
    fill: " "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 16.5509V12.4125H148.966V18.6214H151.034V22.7598H153.104V18.6214H155.172V20.6893H157.24V16.5509H163.449V12.4125H161.379V14.483H159.311V12.4125H157.24V14.483H155.172V16.5509H151.034Z",
    fill: " "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 16.5509H167.587V18.6188H169.655V16.5509Z",
    fill: " "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M173.791 16.5509H171.723V18.6188H173.791V16.5509Z",
    fill: " "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M180 16.5509H177.932V18.6188H180V16.5509Z",
    fill: " "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 18.6214H159.311V20.6893H161.379V18.6214Z",
    fill: " "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M163.449 20.6893H165.517V16.5509H163.449V20.6893Z",
    fill: " "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M128.277 20.6893V18.6214H126.206V22.7598H130.345V20.6893H128.277Z",
    fill: " "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M138.621 22.7598V20.6893H140.689V14.483H138.621V16.5509H136.551V14.483H138.621V12.4125H140.689V14.483H142.76V12.4125H144.828V14.483H146.896V12.4125L148.966 12.4125L148.966 10.3446H151.034L151.034 12.4125L153.104 12.4125V14.483L155.172 14.483V10.3446H153.104L153.104 8.27679L148.966 8.27678L148.966 4.13839L146.896 4.13839V2.06786H142.76V0H140.689V2.06786H138.621V4.13839H140.689V6.20625H136.551V4.13839H132.415V8.27678H134.483V6.20625H136.551V8.27678H144.828V6.20625H146.896V10.3446H136.551V12.4125H134.483V14.483H132.415V12.4125H130.345V14.483H128.277V16.5509H130.345V18.6214H134.483V16.5509H136.551V18.6214H134.483V20.6893H132.415V22.7598H138.621Z",
    fill: " "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 20.6893H144.828V22.7571H146.896V20.6893Z",
    fill: " "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 20.6893H165.517V22.7571H167.585V20.6893Z",
    fill: " "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 20.6893H173.794V22.7571H175.862V20.6893Z",
    fill: " "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M180 20.6893H177.932V22.7571H180V20.6893Z",
    fill: " "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 22.7598H130.345V24.8277H132.412V22.7598Z",
    fill: " "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 22.7598H153.104V24.8277H155.172V22.7598Z",
    fill: " "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 28.9661H161.379V24.8277H165.517V22.7598H163.449V20.6893H161.379V22.7598H159.311V20.6893H157.24V28.9661Z",
    fill: " "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 24.8277V26.8955H171.723V20.6893H169.655V22.7598H167.587V24.8277H169.655Z",
    fill: " "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 24.8277H132.415V26.8955H134.483V24.8277Z",
    fill: " "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 24.8277V20.6893H140.689L140.689 24.8277H136.551V26.8955H146.896V24.8277H142.76Z",
    fill: " "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 24.8277H165.517L165.517 26.8955H163.449V28.9661H165.517V31.0339H163.449V33.1045H161.379V31.0339H159.311V35.1723H157.24V37.2402H155.172V39.3107H159.311V41.3786H161.379V39.3107H163.449V37.2402H161.379V35.1723H165.517V33.1045H167.587V28.9661H169.655L169.655 26.8955H167.587V24.8277Z",
    fill: " "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 24.8277H173.794V26.8955H175.862V24.8277Z",
    fill: " "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M180 31.0339V24.8277H177.932V26.8955H175.862L175.862 28.9661H177.932V31.0339H180Z",
    fill: " "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M163.446 28.9661H161.379L161.379 31.0339L163.446 31.0339V28.9661Z",
    fill: " "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M124.138 28.9661H126.206V33.1045H128.277V31.0339H136.551V28.9661H132.415V26.8955H126.206V24.8277H124.138V26.8955H120V24.8277H117.932V26.8955H115.862V28.9661H117.932V31.0339H120V28.9661H122.068V33.1045H124.138V28.9661Z",
    fill: " "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 33.1045V28.9661H138.621V31.0339L136.551 31.0339V33.1045H140.689Z",
    fill: " "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M144.828 28.9661H142.76V33.1045H144.828V28.9661Z",
    fill: " "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 33.1045H171.723V35.1723H173.794V28.9661L169.655 28.9661L169.655 33.1045Z",
    fill: " "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M177.929 31.0339H175.862V33.1018H177.929V31.0339Z",
    fill: " "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 33.1045H120V35.1723H122.068V33.1045Z",
    fill: " "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 33.1045H128.277V35.1723H130.345V33.1045Z",
    fill: " "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 33.1045H132.415V35.1723H134.483V33.1045Z",
    fill: " "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M148.966 35.1723H151.034V39.3107H153.104V37.2402H155.172V33.1045H157.24V31.0339H155.172V26.8955H153.104L153.104 24.8277H151.034L151.034 22.7598H146.896V24.8277H148.966V26.8955H151.034V31.0339H153.104V33.1045H151.034V31.0339H146.896V33.1045H148.966V35.1723Z",
    fill: " "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 33.1045L167.587 33.1045V35.1723H169.655V33.1045Z",
    fill: " "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 37.2402H142.76V33.1045H140.689L140.689 37.2402Z",
    fill: " "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 35.1723H165.517L165.517 37.2402H167.585V35.1723Z",
    fill: " "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 39.3107V41.3786H138.621V37.2402H136.551V35.1723L134.483 35.1723V37.2402H132.415V39.3107H136.551Z",
    fill: " "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M171.723 39.3107V37.2402H167.587V39.3107H171.723Z",
    fill: " "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 39.3107H130.345V37.2402H126.206V33.1045H124.138V35.1723H122.068V37.2402H120V41.3786L122.068 41.3786V39.3107Z",
    fill: " "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 39.3107L130.345 39.3107V41.3786H132.412V39.3107Z",
    fill: " "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M148.966 35.1723L146.896 35.1723L146.896 33.1045L144.828 33.1045V37.2402H146.896V43.4491H148.966L148.966 35.1723Z",
    fill: " "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 41.3786V43.4491H173.794V45.517H177.932V43.4491H180V41.3786H177.932V39.3107L171.723 39.3107V41.3786H175.862Z",
    fill: " "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 41.3786H124.138V43.4464H126.206V41.3786Z",
    fill: " "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 43.4491V41.3786H132.415V43.4491H130.345V45.517H132.415V43.4491H134.483Z",
    fill: " "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M138.621 49.6554V47.5848H140.689V45.517H138.621V43.4491H142.76V41.3786H144.828V39.3107H140.689V41.3786H138.621V43.4464H136.551V49.6554H132.415V47.5875H126.206V45.517H124.138V47.5875H120V49.6554H117.932V47.5875H115.862V49.6554H113.794L113.794 45.517H111.723V41.3786H107.587V43.4491H109.655V49.6554H103.449V43.4491H105.517V41.3786H101.379V47.5875H97.2402V45.517H99.3107V43.4491H97.2402V41.3786H91.0339V43.4491L88.9661 43.4491L88.9661 47.5875H91.0339V45.517H95.1723V49.6554H97.2402V53.7938H99.3107V51.7232H109.655V53.7938H113.794V51.7232H120V49.6554H122.068V53.7938H124.138V49.6554H126.206V53.7938H128.277V51.7232H136.551V49.6554H138.621Z",
    fill: " "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M180 45.517H177.932V47.5848H180V45.517Z",
    fill: " "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M148.963 47.5875H146.896V49.6554H148.963V47.5875Z",
    fill: " "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 49.6554H173.794L173.794 45.517H171.723V41.3786H161.379L161.379 43.4491H169.655V49.6554H163.449V47.5875H157.24V45.517H159.311V43.4491H157.24V41.3786H151.034V43.4491H148.966V47.5875H151.034V45.517H155.172V49.6554H157.24V53.7938H159.311V51.7232H169.655V53.7938H173.794V51.7232H180V49.6554H177.932V47.5875H175.862V49.6554Z",
    fill: " "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 51.7232V53.7938H155.172V51.7232H153.104V49.6554H148.966V51.7232H151.034Z",
    fill: " "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M180 57.9321H177.932V60H180V57.9321Z",
    fill: " "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 60V64.1384H180V62.0679H177.932V60H175.862Z",
    fill: " "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 57.9321V55.8616H151.034L151.034 53.7938H146.896V55.8616H148.966V60H151.034V57.9321H155.172Z",
    fill: " "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 55.8616H165.517V53.7938H161.379V55.8616H163.449V60H165.517V57.9321H171.723V55.8616H169.655V53.7938H167.587V55.8616Z",
    fill: " "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 55.8616H157.24V57.9321L155.172 57.9321V60H157.24V62.0679H159.311V60H161.379L161.379 55.8616Z",
    fill: " "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 60H167.587V64.1384H169.655V60Z",
    fill: " "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M180 57.9321V55.8616H175.862V57.9321L177.932 57.9321H180Z",
    fill: " "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 60V57.9321L171.723 57.9321V60H175.862Z",
    fill: " "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M173.794 70.3446V68.2768H180V66.2063H165.517V68.2768H169.655V70.3446H173.794Z",
    fill: " "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 70.3446V72.4152H165.517V74.483H171.723V72.4152H169.655V70.3446H167.587Z",
    fill: " "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M180 74.483V72.4152H175.862V74.483H180Z",
    fill: " "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 45.517H132.415V47.5848H134.483V45.517Z",
    fill: " "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 53.7938H120V55.8616H122.068V53.7938Z",
    fill: " "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 53.7938H128.277V55.8616H130.345V53.7938Z",
    fill: " "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 53.7938H132.415V55.8616H134.483V53.7938Z",
    fill: " "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 57.9321L126.206 53.7938H124.138L124.138 55.8616H122.068V57.9321H120V55.8616H115.862V57.9321H120V62.0679H122.068V60H130.345V57.9321H126.206Z",
    fill: " "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 62.0679H124.138V64.1357H126.206V62.0679Z",
    fill: " "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M132.415 62.0679V60H136.551V62.0679H138.621V60H140.689V57.9321H144.828V60H146.896V55.8616H144.828V53.7938H146.896V51.7232H144.828V47.5875H146.896L146.896 43.4491H144.828V45.517H142.76V47.5875H140.689V51.7232H136.551V53.7938H142.76V55.8616H140.689V57.9295H136.551V55.8616H134.483V57.9295H132.412V60H130.345V62.0679H132.412V64.1384H130.345V66.2063H134.483V62.0679H132.415Z",
    fill: " "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 60L151.034 62.0679H148.966V64.1384H151.034V66.2063H153.104V68.2768H155.172V64.1384H153.104V62.0679H155.172V60H151.034Z",
    fill: " "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M163.446 60H161.379L161.379 62.0679H163.446V60Z",
    fill: " "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M159.311 64.1384V68.2768H161.379V66.2062H163.449V64.1384H159.311Z",
    fill: " "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 68.2768H155.172V70.3446H157.24V68.2768Z",
    fill: " "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 76.5509V78.6214H134.483V76.5509H130.345Z",
    fill: " "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 78.6214V76.5509H142.76V78.6214H146.896Z",
    fill: " "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 76.5509H167.587V78.6188H169.655V76.5509Z",
    fill: " "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M171.723 78.6214H173.794V76.5509H175.862V74.483L171.723 74.483V78.6214Z",
    fill: " "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M180 76.5509H177.932V78.6188H180V76.5509Z",
    fill: " "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M120 82.7598H122.068V78.6214H120V82.7598Z",
    fill: " "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 78.6214H159.311V80.6893H161.379V78.6214Z",
    fill: " "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M163.449 80.6893H165.517V76.5509H163.449V80.6893Z",
    fill: " "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M128.277 80.6893V78.6214H126.206V82.7598H130.345V80.6893H128.277Z",
    fill: " "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 82.7598H138.619V80.692H140.687V74.4857H138.619V72.4152H140.687V74.4857H142.754V72.4152H144.825V74.4857H146.893V72.4152H148.963V70.3473H151.031V72.4152H153.099V74.4857H155.17V76.5536H151.031V72.4152H148.963V78.6214H151.031V82.7598H153.099V78.6214H155.167V80.6893H157.235V76.5509H163.441V72.4125H161.373V74.4804H159.305V72.4125H157.235V74.4804H155.167V70.342H153.096V68.2714H148.961V64.1357H146.89V62.0652H142.752V59.9973H140.684V62.0652H138.616V64.1357H140.684V66.2036H138.616V64.1357H136.546V66.2036H134.478V68.2714H132.407V70.342H130.339V68.2714H128.269V66.2036H126.201V76.5482H128.269V70.342H130.339V72.4098H132.407V70.342H136.546V74.4804H138.616V76.5482H136.548V78.6161H134.48V80.6839H132.412V82.7518H136.551V82.7598ZM138.621 68.2741H144.828V66.2062H146.896V70.3446H138.621V68.2741Z",
    fill: " "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 80.6893H144.828V82.7571H146.896V80.6893Z",
    fill: " "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 80.6893H165.517V82.7571H167.585V80.6893Z",
    fill: " "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 80.6893H173.794V82.7571H175.862V80.6893Z",
    fill: " "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M180 80.6893H177.932V82.7571H180V80.6893Z",
    fill: " "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 82.7598L130.345 82.7598V84.8277H132.412V82.7598Z",
    fill: " "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 66.2063H120V70.3446H122.068V66.2063Z",
    fill: " "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M148.966 95.1723H151.034V99.3107H153.104V97.2402H155.172V93.1045H157.24V91.0339H155.172V86.8955H153.104V84.8277H151.034V82.7598H146.896V84.8277H148.966V86.8955H151.034V91.0339H153.104V93.1045H151.034V91.0339H146.896V93.1045H148.966V95.1723Z",
    fill: " "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 82.7598H153.104L153.104 84.8277H155.172V82.7598Z",
    fill: " "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 88.9661H161.379V84.8277H165.517V82.7598H163.449V80.6893H161.379V82.7598H159.311V80.6893H157.24V88.9661Z",
    fill: " "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 84.8277V86.8955H171.723V80.6893H169.655V82.7598H167.587V84.8277H169.655Z",
    fill: " "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 84.8277H132.415V86.8955H134.483V84.8277Z",
    fill: " "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 84.8277V80.6893H140.689V84.8277H136.551V86.8955H146.896V84.8277L142.76 84.8277Z",
    fill: " "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 84.8277H165.517L165.517 86.8955H163.449V88.9661H165.517V91.0339H163.449V93.1045H161.379V91.0339H159.311V95.1723H157.24V97.2402L155.172 97.2402V99.3107H159.311V101.379H161.379V99.3107H163.449V97.2402H161.379V95.1723H165.517V93.1045H167.587V88.9661H169.655L169.655 86.8955H167.587V84.8277Z",
    fill: " "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 84.8277H173.794V86.8955H175.862V84.8277Z",
    fill: " "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M180 91.0339V84.8277H177.932V86.8955H175.862L175.862 88.9661H177.932V91.0339H180Z",
    fill: " "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 88.9661H138.621V91.0339H136.551V93.1045H140.689V88.9661Z",
    fill: " "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M144.828 88.9661H142.76V93.1045H144.828V88.9661Z",
    fill: " "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M163.446 88.9661L161.379 88.9661L161.379 91.0339L163.446 91.0339V88.9661Z",
    fill: " "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M124.138 88.9661H126.206V93.1045H128.277V91.0339L136.551 91.0339L136.551 88.9661H132.415V86.8955H126.206V84.8277H124.138V86.8955H120V88.9661H122.068V93.1045H124.138V88.9661Z",
    fill: " "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M120 74.483H122.068V78.6214L124.138 78.6214V72.4152H120V74.483Z",
    fill: " "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 93.1045H171.723V95.1723H173.794V88.9661L169.655 88.9661L169.655 93.1045Z",
    fill: " "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 93.1045L120 93.1045V95.1723H122.068V93.1045Z",
    fill: " "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 93.1045L128.277 93.1045V95.1723H130.345V93.1045Z",
    fill: " "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 93.1045H132.415V95.1723H134.483V93.1045Z",
    fill: " "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 97.2402H142.76V93.1045H140.689L140.689 97.2402Z",
    fill: " "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 93.1045L167.587 93.1045V95.1723H169.655V93.1045Z",
    fill: " "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 105.517H134.483V107.588H132.415V109.655H138.621V107.588H136.551V105.517Z",
    fill: " "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 111.723H132.415V115.862H134.483V111.723Z",
    fill: " "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 95.1723L165.517 95.1723L165.517 97.2402H167.585V95.1723Z",
    fill: " "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 97.2402V93.1045H124.138V95.1723H122.068V97.2402H120V101.379H122.068V99.3107H130.345V97.2402H126.206Z",
    fill: " "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M138.621 97.2402H136.551V95.1723H134.483V97.2402H132.415V99.3107H136.551V101.379H138.621V97.2402Z",
    fill: " "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M171.723 99.3107V97.2402H167.587V99.3107H171.723Z",
    fill: " "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 99.3107H130.345V101.379H132.412V99.3107Z",
    fill: " "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M148.966 95.1723H146.896L146.896 93.1045H144.828V97.2402H146.896V103.449H148.966L148.966 95.1723Z",
    fill: " "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M177.932 99.3107L171.723 99.3107V101.379H175.862V103.449H173.794V105.517H177.932V103.449H180V101.379H177.932V99.3107Z",
    fill: " "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 101.379H124.138V103.446H126.206V101.379Z",
    fill: " "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 101.379H132.415V103.446H134.483V101.379Z",
    fill: " "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 103.449V107.588H130.345V105.517H128.277V103.449H126.206Z",
    fill: " "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 109.655H124.138V103.449H120V105.517H122.068V109.655Z",
    fill: " "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M120 115.862H126.206V113.794H122.068V109.655H120V115.862Z",
    fill: " "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 109.655H124.138V111.723H126.206V109.655Z",
    fill: " "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 109.655H128.277V111.723H130.345V109.655Z",
    fill: " "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 113.794H128.277V115.862H130.345V113.794Z",
    fill: " "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M128.274 115.862H126.206V117.929H128.274V115.862Z",
    fill: " "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 117.932H120V120H122.068V117.932Z",
    fill: " "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 117.932H128.277V120H130.345V117.932Z",
    fill: " "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 103.449V101.379H144.828V99.3107H140.689V101.379H138.621V103.449H142.76Z",
    fill: " "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M177.929 95.1723V91.0339H175.862V97.2402H180V95.1723H177.929Z",
    fill: " "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M138.619 103.449H136.551V105.517H138.619V103.449Z",
    fill: " "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 105.517H138.621V107.585H140.689V105.517Z",
    fill: " "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 105.517H165.517V107.585H167.585V105.517Z",
    fill: " "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M180 105.517H177.932V107.585H180V105.517Z",
    fill: " "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M148.963 107.588H146.896V109.655H148.963V107.588Z",
    fill: " "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 109.655H173.794V105.517H171.726V101.379H161.381V107.585H157.243V105.517H159.313V103.449H157.243V101.381H151.037V103.449H148.969V107.587H151.037V105.52H155.175V109.658H157.243V113.796H159.313V111.729H169.658V113.796H173.796V111.729H180.003V109.661H177.935V107.593H175.867V109.661L175.862 109.655ZM169.655 109.655H163.449V103.449H169.655V109.655Z",
    fill: " "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 111.723V113.794H155.172V111.723H153.104V109.655H148.966V111.723H151.034Z",
    fill: " "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 117.932V115.862H151.034L151.034 113.794H146.896V115.862H148.966V120H151.034V117.932H155.172Z",
    fill: " "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 115.862H165.517V113.794H161.379V115.862H163.449V120H165.517V117.932H171.723V115.862H169.655V113.794H167.587V115.862Z",
    fill: " "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M144.828 113.794H146.896V111.723H144.828V107.588H146.896L146.896 103.449H144.828V105.517H142.76V107.588H140.689V111.723H138.621V113.794H140.689V117.932H144.828V120H146.896V115.862H144.828V113.794Z",
    fill: " "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 115.862H157.24V117.932H155.172V120H157.24V122.068H159.311V120H161.379L161.379 115.862Z",
    fill: " "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M180 117.932V115.862H175.862V117.932H180Z",
    fill: " "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 117.932H138.621V120H140.689V117.932Z",
    fill: " "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 120V122.068H173.794V120H175.862V117.932H171.723L171.723 120H169.655Z",
    fill: " "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 124.138H165.517V122.068H163.449V124.138H159.311V128.277H161.379V126.206H163.449V128.277H165.517V126.206H171.723V124.138H169.655L169.655 122.068H167.587V124.138Z",
    fill: " "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 128.277V126.206H171.723V128.277H175.862Z",
    fill: " "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 120V122.068H72.4152V124.138H76.5509V122.068H78.6214V120H74.483Z",
    fill: " "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3107 120H97.2402V122.068H99.3107V120Z",
    fill: " "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 126.206H93.1045V128.277H95.1723V124.138H93.1045V122.068H95.1723V120H91.0339V122.068H88.9661V124.138H91.0339V126.206Z",
    fill: " "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2402 128.277H95.1723V130.345H97.2402V128.277Z",
    fill: " "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 132.413V134.483H82.7598V132.413H84.8277V134.483H86.8955V132.413H88.9661V130.345H91.0339V132.413H93.1045V134.483H95.1723V130.345H93.1045V128.277H88.9661V124.138H86.8955V122.068H82.7598V120H80.6893V122.068H78.6214L78.6214 124.138H80.6893V126.206H76.5509V128.277H84.8277V126.206H86.8955V130.345H76.5509V134.483H78.6214V132.413H80.6893Z",
    fill: " "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 136.551V138.621H74.483V136.551H70.3446Z",
    fill: " "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8955 138.621V136.551H82.7598V138.621H86.8955Z",
    fill: " "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 136.551L91.0339 132.413H88.9661V138.621H91.0339V142.76H93.1045V138.621H95.1723V140.689H97.2402V136.551H103.449V132.413H101.379V134.483H99.3107V132.413H97.2402V134.483L95.1723 134.483V136.551H91.0339Z",
    fill: " "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 136.551H107.588V138.619H109.655V136.551Z",
    fill: " "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 136.551H111.723V138.619H113.791V136.551Z",
    fill: " "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 132.413H107.588V134.48H109.655V132.413Z",
    fill: " "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 132.413H111.723V134.48H113.791V132.413Z",
    fill: " "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M120 136.551H117.932V138.619H120V136.551Z",
    fill: " "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M101.379 138.621H99.3107V140.689H101.379V138.621Z",
    fill: " "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M103.449 140.689H105.517V136.551L103.449 136.551V140.689Z",
    fill: " "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2768 140.689V138.621H66.2063V142.76H70.3446V140.689H68.2768Z",
    fill: " "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6214 142.76V140.689H80.6893L80.6893 134.483H78.6214L78.6214 136.551H76.5509V138.621H74.483L74.483 140.689H72.4152V142.76H78.6214Z",
    fill: " "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8955 140.689H84.8277V142.757H86.8955V140.689Z",
    fill: " "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 140.689L105.517 140.689V142.757H107.585V140.689Z",
    fill: " "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 140.689H113.794V142.757H115.862V140.689Z",
    fill: " "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M117.932 140.689V142.76H122.068V138.621H120V140.689H117.932Z",
    fill: " "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 142.76H70.3446V144.828H72.4125V142.76Z",
    fill: " "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1723 142.76L93.1045 142.76V144.828H95.1723V142.76Z",
    fill: " "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2402 148.966H101.379V144.828H105.517V142.76H103.449V140.689L101.379 140.689L101.379 142.76H99.3107L99.3107 140.689H97.2402L97.2402 148.966Z",
    fill: " "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 144.828V146.896H111.723V140.689H109.655V142.76H107.588V144.828H109.655Z",
    fill: " "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 144.828H72.4152V146.896H74.483V144.828Z",
    fill: " "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7598 144.828V140.689H80.6893L80.6893 144.828H76.5509V146.896H86.8955V144.828H82.7598Z",
    fill: " "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M107.588 144.828H105.517L105.517 146.896H103.449V148.966H105.517V151.034H103.449V153.104H101.379V151.034H99.3107V155.172H97.2402V157.24H95.1723V159.311H99.3107V161.379H101.379V159.311H103.449V157.24H101.379V155.172H105.517V153.104H107.587V148.966H109.655V146.896L107.587 146.896L107.588 144.828Z",
    fill: " "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 144.828H113.794V146.896H115.862V144.828Z",
    fill: " "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M105.517 120H101.379V122.068H103.449V124.138H99.3107V128.277H101.379V126.206H103.449V124.138H105.517V120Z",
    fill: " "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 120H107.588V122.068H109.655V120Z",
    fill: " "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 120H111.723V122.068H113.791V120Z",
    fill: " "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 124.138H105.517V126.206H107.585V124.138Z",
    fill: " "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M105.517 126.206H103.449V128.274H105.517V126.206Z",
    fill: " "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 128.277H105.517V130.345H107.585V128.277Z",
    fill: " "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M111.723 130.345V124.138H109.655V126.206H107.588V128.277H109.655V130.345H111.723Z",
    fill: " "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 128.277H113.794V130.345H115.862V128.277Z",
    fill: " "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M103.446 148.966H101.379L101.379 151.034L103.446 151.034V148.966Z",
    fill: " "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1384 148.966H66.2062V153.104H68.2768V151.034H76.5509V148.966H72.4152V146.896H66.2062V144.828H64.1384V146.896H60V144.828H57.9321V146.896H55.8616V148.966H57.9321V151.034H60V148.966H62.0679V153.104H64.1384V148.966Z",
    fill: " "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 153.104V148.966H78.6214V151.034H76.5509V153.104H80.6893Z",
    fill: " "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8277 148.966H82.7598V153.104H84.8277V148.966Z",
    fill: " "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2768 180H70.3446V175.862H68.2768V180Z",
    fill: " "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4152 177.932V180H76.5509V177.932H72.4152Z",
    fill: " "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 153.104H111.723V155.172H113.794V148.966H109.655V153.104Z",
    fill: " "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M117.929 151.034H115.862V153.102H117.929V151.034Z",
    fill: " "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0679 153.104H60V155.172H62.0679V153.104Z",
    fill: " "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 153.104H68.2768L68.2768 155.172H70.3446V153.104Z",
    fill: " "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 153.104H72.4152V155.172H74.483V153.104Z",
    fill: " "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9661 155.172H91.0339V159.311H93.1045V157.24H95.1723L95.1723 153.104H97.2402V151.034H95.1723V146.896H93.1045V144.828H91.0339L91.0339 142.76L86.8955 142.76V144.828H88.9661V146.896H91.0339V151.034H93.1045V153.104H91.0339V151.034H86.8955V153.104H88.9661V155.172Z",
    fill: " "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 153.104H107.587L107.588 155.172H109.655V153.104Z",
    fill: " "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 157.24H82.7598L82.7598 153.104H80.6893V157.24Z",
    fill: " "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8277 157.24H86.8955V163.449H88.9661V155.172L86.8955 155.172V153.104L84.8277 153.104L84.8277 157.24Z",
    fill: " "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 155.172H105.517V157.24H107.585V155.172Z",
    fill: " "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6214 157.24H76.5509V155.172L74.483 155.172V157.24H72.4152V159.311H76.5509V161.379H78.6214V157.24Z",
    fill: " "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M111.723 159.311V157.24H107.588V159.311H111.723Z",
    fill: " "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0679 159.311H70.3446V157.24H66.2063L66.2062 153.104H64.1384V155.172H62.0679V157.24H60V161.379H62.0679V159.311Z",
    fill: " "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 159.311H70.3446V161.379H72.4125V159.311Z",
    fill: " "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 161.379V159.311H111.723V161.379H115.862Z",
    fill: " "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 161.379H72.4152V163.446H74.483V161.379Z",
    fill: " "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7598 163.449V161.379H84.8277V159.311H80.6893V161.379L78.6214 161.379L78.6214 163.449H82.7598Z",
    fill: " "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M107.588 161.379H101.381V167.585H97.2429V165.517H99.3134V163.449H97.2429V161.381H91.0366V163.449H88.9688V167.587H91.0366V165.52H95.175V169.658H97.2429V173.796H99.3134V171.729H109.658V173.796H113.796V171.729H120.003V169.661H117.935V167.593H115.867V169.661H113.799V165.522H111.731V161.384H107.593L107.588 161.379ZM109.655 169.655H103.449V163.449H109.655V169.655Z",
    fill: " "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6188 163.449H76.5509V165.517H78.6188V163.449Z",
    fill: " "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1384 165.517H62.0679V169.655H68.2741V167.585H64.1384V165.517Z",
    fill: " "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5509 167.585H74.483V165.517H72.4152V167.585H70.3446V169.655H74.483V171.723H76.5509V169.655H78.6214V167.587H76.5509V167.585Z",
    fill: " "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 169.655H68.2768V171.723H70.3446V169.655Z",
    fill: " "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 171.723L70.3446 171.723V173.791H72.4125V171.723Z",
    fill: " "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 163.449H113.794V165.517H115.862V163.449Z",
    fill: " "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 165.517H78.6214V167.585H80.6893V165.517Z",
    fill: " "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M107.585 165.517H105.517V167.585H107.585V165.517Z",
    fill: " "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 167.587V165.517H117.932V167.587H122.068Z",
    fill: " "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9634 167.587H86.8955V169.655H88.9634V167.587Z",
    fill: " "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 171.723V173.794H95.1723V171.723H93.1045V169.655H88.9661V171.723H91.0339Z",
    fill: " "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8277 171.723V167.587H86.8955V163.449H84.8277V165.517H82.7598V167.587H80.6893V171.723H78.6214V173.791H74.483V175.862H76.5509V177.929H78.6214V173.794H86.8955V171.723H84.8277Z",
    fill: " "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M107.587 175.862H105.517V173.794H101.379V175.862H103.449V180H105.517V177.932H111.723V175.862H109.655V173.794H107.587V175.862Z",
    fill: " "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 175.862V177.932H84.8277V180H86.8955V175.862H80.6893Z",
    fill: " "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0339 175.862L91.0339 173.794L86.8955 173.794V175.862L88.9661 175.862V180H91.0339V177.932H95.1723V175.862H91.0339Z",
    fill: " "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2402 175.862V177.932L95.1723 177.932L95.1723 180H101.379V175.862L97.2402 175.862Z",
    fill: " "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M120 177.932V175.862H115.862V177.932H120Z",
    fill: " "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6893 177.932H78.6214V180H80.6893V177.932Z",
    fill: " "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M115.862 180V177.932L111.723 177.932V180H115.862Z",
    fill: " "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 165.517V161.379H132.415V163.449H130.345V165.517H134.483Z",
    fill: " "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 165.517H138.621V163.449H136.551V165.517H134.483V167.587H136.551V169.655H134.483V167.587H132.415V169.655H130.345V165.517H126.206V161.379H124.138V167.587H128.277V173.794H130.345V171.723H136.551V169.655H138.621V167.587H136.551V165.517Z",
    fill: " "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M132.415 175.862V177.932H136.551V175.862H132.415Z",
    fill: " "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 177.932V171.723H122.071V173.794H124.138V175.862H122.068V180H132.415V177.932H126.206Z",
    fill: " "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 120L151.034 122.068H148.966V124.138H151.034V126.206H153.104V128.277H155.172V124.138H153.104V122.068H155.172V120H151.034Z",
    fill: " "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M163.446 120H161.379L161.379 122.068H163.446V120Z",
    fill: " "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 128.277H155.172V130.345H157.24V128.277Z",
    fill: " "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 132.413H130.345V134.48H132.412V132.413Z",
    fill: " "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 136.551V138.621H134.483V136.551H130.345Z",
    fill: " "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 138.621V136.551H142.76V138.621H146.896Z",
    fill: " "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M173.794 136.551H171.723V138.621H173.794V136.551H175.862V134.483H173.794V136.551Z",
    fill: " "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M161.379 138.621H159.311V140.689H161.379V138.621Z",
    fill: " "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M163.449 140.689H165.517V136.551H163.449V140.689Z",
    fill: " "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M128.277 140.689V138.621H126.206V142.76H130.345V140.689H128.277Z",
    fill: " "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M138.621 142.76V140.689H140.689V134.483H138.621V132.413H140.689V134.483H142.757V132.413H144.828V134.483H146.896V132.413H148.966V130.345H151.034V132.413H153.102V134.483H155.172V136.551H151.034V132.413H148.966V138.621H151.034V142.76H153.104V138.621H155.172V140.689H157.24V136.551L163.449 136.551V132.413H161.379V134.483H159.311V132.413H157.24V134.483H155.172V130.345H153.102V128.274H148.966V124.138H146.896V122.068H142.757V120H140.689V122.068H138.621V124.138H140.689V126.206H136.551V124.138H134.483V122.068H138.621V120H136.551V115.862H134.483V120H132.413V122.068H130.345V124.138H132.413V126.206H134.483V128.274H144.828V126.206H146.896V130.345H134.483V128.274H130.345V124.138H128.274V122.068H124.138V120H122.068V122.068H120V120H115.862V124.138H113.794V126.206H117.929V124.136H120V124.138H122.068V126.206H117.929V128.274H126.206V126.206H128.274V130.345H117.929V134.483H120V132.413H122.068V134.483H124.138V132.413H126.206V134.483H128.274V132.413H130.345V130.345H132.413L132.412 132.413H134.483V134.483H138.621V136.551H136.551V138.621H134.483V140.689H132.415V142.76H138.621Z",
    fill: " "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 140.689H144.828V142.757H146.896V140.689Z",
    fill: " "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 140.689L165.517 140.689V142.757H167.585V140.689Z",
    fill: " "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 140.689H173.794V142.757H175.862V140.689Z",
    fill: " "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M180 140.689H177.932V142.757H180V140.689Z",
    fill: " "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 142.76H130.345V144.828H132.412V142.76Z",
    fill: " "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 153.104H157.24V151.034H155.172V146.896H153.104V144.828H151.034V142.76H146.896V144.828H148.966V146.896H151.034V151.034H153.104V153.104H151.034V151.034H146.896V153.104H148.966V155.172H151.034V159.311H153.104V157.24H155.172V153.104Z",
    fill: " "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 142.76H153.104L153.104 144.828H155.172V142.76Z",
    fill: " "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 148.966H161.379V144.828H165.517V142.76H163.449V140.689L161.379 140.689V142.76H159.311V140.689H157.24V148.966Z",
    fill: " "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 144.828V146.896H171.723V140.689H169.655V142.76H167.587V144.828H169.655Z",
    fill: " "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 132.415H165.517V134.483H167.585V132.415Z",
    fill: " "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 138.621H169.655V134.483H167.587V138.621Z",
    fill: " "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 128.277V130.345H169.655V134.483H171.723V130.345H169.655V128.277H167.587Z",
    fill: " "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 144.828H132.415V146.896H134.483V144.828Z",
    fill: " "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 144.828V140.689H140.689L140.689 144.828H136.551V146.896H146.896V144.828H142.76Z",
    fill: " "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 144.828H165.517L165.517 146.896H163.449V148.966H165.517V151.034H163.449V153.104H161.379V151.034H159.311V155.172H157.24V157.24H155.172V159.311H159.311V161.379H161.379V159.311H163.449V157.24H161.379V155.172H165.517V153.104H167.587V148.966H169.655L169.655 146.896L167.587 146.896V144.828Z",
    fill: " "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 144.828H173.794V146.896H175.862V144.828Z",
    fill: " "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M177.932 146.896H175.862L175.862 148.966H177.932V151.034H180V144.828H177.932V146.896Z",
    fill: " "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M177.932 128.277H180V124.138H175.862V126.206H177.932V128.277Z",
    fill: " "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 130.345H173.794V132.412H175.862V130.345Z",
    fill: " "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M180 130.345H177.932V132.412H180V130.345Z",
    fill: " "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M177.932 138.621H180V134.483H177.932V138.621Z",
    fill: " "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 148.966H138.621V151.034H136.551V153.104H140.689V148.966Z",
    fill: " "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M144.828 148.966H142.76V153.104H144.828V148.966Z",
    fill: " "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M163.446 148.966H161.379L161.379 151.034L163.446 151.034V148.966Z",
    fill: " "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M124.138 148.966H126.206V153.104H128.277V151.034H136.551V148.966H132.415V146.896H126.206V144.828H124.138V146.896H120V144.828H117.932V146.896H115.862V148.966H117.932V151.034H120V148.966H122.068V153.104H124.138V148.966Z",
    fill: " "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 153.104H171.723V155.172H173.794V148.966H169.655L169.655 153.104Z",
    fill: " "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M177.929 151.034H175.862V153.102H177.929V151.034Z",
    fill: " "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M122.068 153.104H120V155.172H122.068V153.104Z",
    fill: " "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M130.345 153.104H128.277V155.172H130.345V153.104Z",
    fill: " "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M134.483 153.104H132.415V155.172H134.483V153.104Z",
    fill: " "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 157.24H142.76V153.104H140.689L140.689 157.24Z",
    fill: " "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M146.896 153.104L144.828 153.104V157.24H146.896V163.449H148.966L148.966 155.172L146.896 155.172L146.896 153.104Z",
    fill: " "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M169.655 153.104H167.587V155.172H169.655V153.104Z",
    fill: " "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M167.585 155.172H165.517L165.517 157.24H167.585V155.172Z",
    fill: " "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M126.206 157.24V153.104H124.138V155.172H122.068V157.24H120V161.379H122.068V159.311H130.345V157.24H126.206Z",
    fill: " "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M136.551 159.311V161.379H138.621V157.24H136.551V155.172L134.483 155.172V157.24H132.415V159.311H136.551Z",
    fill: " "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M171.723 159.311V157.24H167.587V159.311H171.723Z",
    fill: " "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M132.412 159.311H130.345V161.379H132.412V159.311Z",
    fill: " "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M177.932 159.311H171.723V161.379H175.862V163.449H173.794V165.517H177.932V163.449H180V161.379H177.932V159.311Z",
    fill: " "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76 163.449V161.379H144.828V159.311H140.689V161.379L138.621 161.379V163.449H142.76Z",
    fill: " "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 165.517H138.621V167.585H140.689V165.517Z",
    fill: " "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M148.966 167.587H151.034V165.517H155.172V169.655H157.24V173.794H159.311V167.587H157.24V165.517H159.311V163.449H157.24V161.379H151.034V163.449H148.966V167.587Z",
    fill: " "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M180 165.517L177.932 165.517V167.585H180V165.517Z",
    fill: " "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M148.963 167.587H146.896V169.655H148.963V167.587Z",
    fill: " "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 169.655H171.723V167.587H173.794L173.794 165.517L171.723 165.517V161.379H161.379L161.379 167.587H163.449V163.449H169.655V169.655H165.517V171.723H169.655V173.794H173.794V171.723H180V169.655H177.932V167.587H175.862V169.655Z",
    fill: " "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 171.723V173.794H155.172V171.723H153.104V169.655H148.966V171.723H151.034Z",
    fill: " "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M144.828 173.794H146.896V171.723H144.828V167.587H146.896L146.896 163.449H144.828V165.517H142.76V167.587H140.689V171.723H138.621V173.794H140.689V177.932H144.828V180H146.896V175.862H144.828V173.794Z",
    fill: " "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M167.587 175.862H165.517V173.794H161.379V175.862H163.449V180H165.517V177.932H171.723V175.862H169.655V173.794H167.587V175.862Z",
    fill: " "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M151.034 175.862L151.034 173.794L146.896 173.794V175.862L148.966 175.862V180H151.034V177.932H155.172V175.862H151.034Z",
    fill: " "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M157.24 175.862V177.932L155.172 177.932V180H161.379L161.379 175.862L157.24 175.862Z",
    fill: " "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M180 177.932V175.862H175.862V177.932H180Z",
    fill: " "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 177.932H138.621V180H140.689V177.932Z",
    fill: " "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 180V177.932L171.723 177.932V180H175.862Z",
    fill: " "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 60H16.5509V62.0679H18.6188V60Z",
    fill: " "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 60L31.0339 62.0679H28.9661V64.1384H31.0339V66.2063H33.1045V68.2768H35.1723V64.1384H33.1045V62.0679H35.1723V60H31.0339Z",
    fill: " "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3786 62.0679H49.6554V68.2768H43.4491V70.3446H49.6554V72.4152H53.7938V70.3446H60V68.2768H57.9321V66.2062L55.8616 66.2063V68.2768H53.7938V64.1384H51.7232V60H45.517H43.4491H41.3786V62.0679Z",
    fill: " "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4491 64.1384H39.3107V68.2768H41.3786V66.2062H43.4491V64.1384Z",
    fill: " "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 66.2063V68.2768H24.8277V66.2063H16.5509Z",
    fill: " "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 68.2768H35.1723V70.3446H37.2402V68.2768Z",
    fill: " "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 72.4125V74.483H22.7598V72.4125H24.8277V74.483H26.8955V72.4125H28.9661V70.3446H31.0339V72.4125H33.1045V74.483H35.1723V70.3446H33.1045L33.1045 68.2768H28.9661V64.1384H26.8955V62.0679H22.7598V60H20.6893V62.0679H18.6214V64.1384H24.8277V66.2063H26.8955V70.3446H16.5509V74.483H18.6214V72.4125H20.6893Z",
    fill: " "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 43.4491H0V45.517H2.06786V43.4491Z",
    fill: " "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13571 45.517L2.06786 45.517V47.5848H4.13571V45.517Z",
    fill: " "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 41.3786H12.4152V47.5875H14.483V41.3786Z",
    fill: " "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 47.5875H0V49.6554H2.06786V47.5875Z",
    fill: " "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 47.5875H10.3446V49.6554H12.4125V47.5875Z",
    fill: " "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 49.6554H12.4152V51.7232H14.483V49.6554Z",
    fill: " "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 53.7938H10.3446V55.8616H12.4152V60H14.483V57.9321H16.5509V55.8616H14.483V53.7938Z",
    fill: " "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 55.8616V53.7938H10.3446L10.3446 51.7232H6.20625V49.6554H8.27679V47.5875H10.3446L10.3446 43.4491H8.27679V45.517H6.20625V47.5875H4.13839V51.7232H2.06786V53.7938H4.13839V57.9321H8.27679V60H10.3446L10.3446 55.8616H6.20625Z",
    fill: " "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13571 57.9321H2.06786V60H4.13571V57.9321Z",
    fill: " "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 60H0V62.0679H2.06786V60Z",
    fill: " "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 62.0679L2.06786 64.1384H8.27679V66.2063H10.3446V70.3446H0V74.483H2.06786V72.4125H4.13839V74.483H6.20625V72.4125H8.27679V74.483H10.3446V72.4125H12.4152V70.3446H14.483V68.2768H12.4152V64.1384H10.3446V62.0679H6.20625V60H4.13839V62.0679H2.06786Z",
    fill: " "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 62.0679H12.4152V64.1357H14.483V62.0679Z",
    fill: " "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M0 66.2063V68.2768H8.27679V66.2063H0Z",
    fill: " "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 72.4125H12.4152L12.4152 74.4804H14.483V72.4125Z",
    fill: " "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 76.5509V78.6214H14.483V76.5509H10.3446Z",
    fill: " "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 76.5509V78.6214H26.8955V76.5509H22.7598Z",
    fill: " "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9321 78.6214H60V74.483H55.8616V76.5509H57.9321V78.6214Z",
    fill: " "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3786 78.6214H39.3107V80.6893H41.3786V78.6214Z",
    fill: " "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 78.6214H0V82.7598H2.06786V78.6214Z",
    fill: " "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27679 80.6893V78.6214H6.20625V82.7598H10.3446V80.6893H8.27679Z",
    fill: " "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6214 82.7598V80.6893H20.6893V74.483H18.6214V76.5509H16.5509V78.6214H14.483V80.6893H12.4152V82.7598H18.6214Z",
    fill: " "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 80.6893H24.8277V82.7571H26.8955V80.6893Z",
    fill: " "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 80.6893H45.517V82.7571H47.5848V80.6893Z",
    fill: " "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 80.6893H53.7938V82.7571H55.8616V80.6893Z",
    fill: " "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80.6893H57.9321V82.7571H60V80.6893Z",
    fill: " "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 82.7598L10.3446 82.7598V84.8277H12.4125V82.7598Z",
    fill: " "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 82.7598V84.8277H28.9661V86.8955H31.0339V91.0339H33.1045V93.1045H31.0339V91.0339H26.8955V93.1045H28.9661V95.1723H31.0339V99.3107H33.1045V97.2402H35.1723V93.1045H37.2402V91.0339H35.1723V86.8955H33.1045V84.8277H31.0339L31.0339 82.7598H26.8955Z",
    fill: " "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1723 82.7598H33.1045L33.1045 84.8277H35.1723V82.7598Z",
    fill: " "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 88.9661H41.3786V84.8277H45.517V82.7598H43.4491V80.6893H41.3786V82.7598H39.3107L39.3107 80.6893H37.2402V88.9661Z",
    fill: " "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 84.8277V86.8955H51.7232V80.6893H49.6554V82.7598H47.5875V84.8277H49.6554Z",
    fill: " "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 84.8277H12.4152V86.8955H14.483V84.8277Z",
    fill: " "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 84.8277V80.6893H20.6893V84.8277H16.5509V86.8955H26.8955V84.8277L22.7598 84.8277Z",
    fill: " "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 84.8277H45.517L45.517 86.8955H43.4491V88.9661H45.517V91.0339H43.4491V93.1045H41.3786V91.0339H39.3107V95.1723H37.2402V97.2402L35.1723 97.2402V99.3107H39.3107V101.379H41.3786V99.3107H43.4491V97.2402H41.3786V95.1723H45.517V93.1045H47.5875V88.9661H49.6554V86.8955H47.5875V84.8277Z",
    fill: " "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 84.8277H53.7938V86.8955H55.8616V84.8277Z",
    fill: " "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 88.9661H18.6214V91.0339H16.5509V93.1045H20.6893V88.9661Z",
    fill: " "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8277 88.9661H22.7598V93.1045H24.8277V88.9661Z",
    fill: " "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4464 88.9661L41.3786 88.9661V91.0339L43.4464 91.0339V88.9661Z",
    fill: " "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91.0339V84.8277H57.9321V86.8955H55.8616V88.9661H57.9321V91.0339H60Z",
    fill: " "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13839 88.9661H6.20625V93.1045H8.27679V91.0339L16.5509 91.0339V88.9661H12.4152L12.4152 86.8955H6.20625V84.8277H4.13839V86.8955H0V88.9661H2.06786V93.1045H4.13839V88.9661Z",
    fill: " "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 93.1045H51.7232V95.1723H53.7938V88.9661L49.6554 88.9661V93.1045Z",
    fill: " "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9295 91.0339H55.8616V93.1018H57.9295V91.0339Z",
    fill: " "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 93.1045L0 93.1045V95.1723H2.06786L2.06786 93.1045Z",
    fill: " "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 93.1045L8.27679 93.1045V95.1723H10.3446V93.1045Z",
    fill: " "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 93.1045H12.4152V95.1723H14.483V93.1045Z",
    fill: " "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 97.2402H22.7598V93.1045H20.6893V97.2402Z",
    fill: " "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 93.1045L47.5875 93.1045V95.1723H49.6554V93.1045Z",
    fill: " "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 95.1723L45.517 95.1723V97.2402H47.5848V95.1723Z",
    fill: " "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 97.2402L6.20625 93.1045H4.13839L4.13839 95.1723H2.06786V97.2402H0V101.379H2.06786V99.3107H10.3446V97.2402H6.20625Z",
    fill: " "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6214 97.2402H16.5509V95.1723H14.483V97.2402H12.4152V99.3107H16.5509V101.379H18.6214V97.2402Z",
    fill: " "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7232 99.3107V97.2402H47.5875V99.3107H51.7232Z",
    fill: " "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 117.932H0V120H2.06786V117.932Z",
    fill: " "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 115.862H12.4125V117.929H14.483V115.862Z",
    fill: " "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 117.929H14.483V120H16.5509V117.929Z",
    fill: " "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 124.138H6.20625V122.068H4.13839V120H2.06786L2.06786 122.068H0V128.277H2.06786V124.138Z",
    fill: " "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13571 128.277H2.06786L2.06786 130.345H4.13571V128.277Z",
    fill: " "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27679 132.413V128.277H10.3446V126.206H8.27679V124.138H10.3446V126.206H12.4125V122.068H14.483L14.483 120H10.3446V122.068H8.27679V120H6.20625V115.862H8.27411V117.929H10.3446V115.862H12.4125L12.4125 113.791H10.3446V111.723H14.483V109.655H12.4152V107.588H10.3446V111.723H8.27411V113.791H6.20625V109.655H4.13839V111.723H2.06786V113.791H0V115.862H4.13839V120H6.20625V122.068H8.27411V124.138H6.20625V126.206H4.13839V128.277H6.20625V130.345H4.13839V132.413H2.06786L2.06786 130.345L0 130.345V142.76H2.06786V138.621H4.13839V136.551H2.06786V134.483H6.20625V132.413H8.27679Z",
    fill: " "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 132.412H12.4125V134.483H14.483V128.277H10.3446L10.3446 132.412Z",
    fill: " "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 132.412L8.27679 132.413V134.48H10.3446V132.412Z",
    fill: " "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27411 134.483L6.20625 134.483L6.20625 136.551H8.27411V134.483Z",
    fill: " "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 99.3107H10.3446V101.379H12.4125V99.3107Z",
    fill: " "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9661 95.1723H26.8955V93.1045H24.8277V97.2402H26.8955V103.449H28.9661V95.1723Z",
    fill: " "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 101.379V103.449H53.7938V105.517H57.9321V103.449H60V101.379H57.9321V99.3107L51.7232 99.3107V101.379H55.8616Z",
    fill: " "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 101.379H4.13839V103.446H6.20625V101.379Z",
    fill: " "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 105.517V107.588H10.3446V105.517H2.06786Z",
    fill: " "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 101.379H12.4152V103.446H14.483V101.379Z",
    fill: " "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 103.449V101.379H24.8277V99.3107H20.6893V101.379H18.6214V103.449H22.7598Z",
    fill: " "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 103.449H16.5509V105.517H18.6188V103.449Z",
    fill: " "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 105.517H18.6214V107.585H20.6893V105.517Z",
    fill: " "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 105.517H45.517V107.585H47.5848V105.517Z",
    fill: " "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M60 105.517H57.9321V107.585H60V105.517Z",
    fill: " "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 107.588H16.5509V109.655H18.6188V107.588Z",
    fill: " "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9634 107.588H26.8955V109.655H28.9634V107.588Z",
    fill: " "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 109.655H53.7938V105.517H51.7259V101.379H41.3813V107.585H37.2429V105.517H39.3134V103.449H37.2429V101.381H31.0366V103.449H28.9688V107.587H31.0366V105.52H35.175V109.658H37.2429V113.796H39.3134V111.729H49.658V113.796H53.7964V111.729H60.0027V109.661H57.9348V107.593H55.867V109.661L55.8616 109.655ZM49.6554 109.655H43.4491V103.449H49.6554V109.655Z",
    fill: " "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 111.723V113.794H35.1723V111.723H33.1045V109.655H28.9661V111.723H31.0339Z",
    fill: " "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 113.794V115.862H28.9661V120H31.0339V117.932H35.1723V115.862H31.0339L31.0339 113.794H26.8955Z",
    fill: " "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 115.862H45.517V113.794H41.3786V115.862H43.4491V120H45.517V122.068H43.4491V120H41.3786V122.068H43.4491V124.138H39.3107V128.277H41.3786V126.206H43.4491V124.138H45.517V126.206H47.5875V128.277H49.6554V124.138H47.5875V122.068H49.6554V120H45.517V117.932H51.7232V115.862H49.6554V113.794H47.5875V115.862Z",
    fill: " "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8277 117.932V120H26.8955V115.862H24.8277V113.794H26.8955V111.723H24.8277V107.588H26.8955V103.449H24.8277V105.517H22.7598V107.588H20.6893V111.723H18.6214V113.794H20.6893V117.932H24.8277Z",
    fill: " "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M60 117.932V115.862H55.8616V117.932H60Z",
    fill: " "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 117.932H18.6214V120H20.6893V117.932Z",
    fill: " "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 120V122.068H39.3107V120H41.3786V115.862H37.2402V117.932H35.1723V120H37.2402Z",
    fill: " "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 120H16.5509V122.068H18.6188V120Z",
    fill: " "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 120L31.0339 122.068H28.9661V124.138H31.0339V126.206H33.1045V128.277H35.1723V124.138H33.1045V122.068H35.1723V120H31.0339Z",
    fill: " "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 122.068H14.483L14.483 124.136H16.5509V122.068Z",
    fill: " "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 128.277H35.1723V130.345H37.2402V128.277Z",
    fill: " "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 132.413V134.483H22.7598V132.413H24.8277V134.483H26.8955V132.413H28.9661V130.345H31.0339V132.413H33.1045V134.483H35.1723V130.345H33.1045L33.1045 128.277H28.9661V124.138H26.8955V122.068H22.7598V120H20.6893V122.068H18.6214V124.138H20.6893V126.206H16.5509V128.277H24.8277V126.206H26.8955V130.345H16.5509V134.483H18.6214V132.413H20.6893Z",
    fill: " "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7232 122.068H53.7938V120H55.8616V122.068H57.9321V120H55.8616L55.8616 117.932H51.7232V122.068Z",
    fill: " "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7938 124.138V128.277H55.8616V126.206H57.9321V124.138H53.7938Z",
    fill: " "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 128.277H43.4491V130.345H45.517V132.412H47.5875V134.483H49.6554V130.345H47.5875V128.277Z",
    fill: " "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7232 128.277H49.6554L49.6554 130.345H51.7232V128.277Z",
    fill: " "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3786 132.413V134.483H39.3107V132.413H37.2402V134.483L35.1723 134.483V136.551H31.0339V132.413H28.9661V138.621H31.0339V142.76H33.1045V138.621H35.1723V140.689H37.2402V136.551H43.4491V140.689H45.517L45.517 132.412L41.3786 132.413Z",
    fill: " "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 136.551V138.621H26.8955V136.551H22.7598Z",
    fill: " "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 136.551V138.621H49.6554V136.551H51.7232V138.621H53.7938V136.551H57.9321V132.413H55.8616V134.483H53.7938V132.413H51.7232V134.483L49.6554 134.483V136.551H47.5875Z",
    fill: " "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M60 136.551L57.9321 136.551V138.619H60V136.551Z",
    fill: " "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3786 138.621H39.3107V140.689H41.3786V138.621Z",
    fill: " "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27679 140.689V138.621H14.483V136.551H8.27679V138.621H6.20625V142.76H10.3446V140.689H8.27679Z",
    fill: " "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4152 140.689V142.76H18.6214V140.689H20.6893V134.483H18.6214V136.551H16.5509V138.621H14.483V140.689H12.4152Z",
    fill: " "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 140.689H24.8277V142.757H26.8955V140.689Z",
    fill: " "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 140.689H45.517V142.757H47.5848V140.689Z",
    fill: " "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 140.689H53.7938V142.757H55.8616V140.689Z",
    fill: " "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9321 140.689V142.76H62.0679V138.621H60V140.689H57.9321Z",
    fill: " "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 142.76H10.3446V144.828H12.4125V142.76Z",
    fill: " "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8955 142.76V144.828H28.9661V146.896H31.0339V151.034H33.1045V153.104H31.0339V151.034H26.8955V153.104H28.9661V155.172H31.0339V159.311H33.1045V157.24H35.1723V153.104H37.2402V151.034H35.1723V146.896H33.1045V144.828H31.0339L31.0339 142.76L26.8955 142.76Z",
    fill: " "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1723 142.76L33.1045 142.76L33.1045 144.828H35.1723V142.76Z",
    fill: " "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 148.966H41.3786V144.828H45.517V142.76H43.4491L43.4491 140.689H41.3786V142.76H39.3107L39.3107 140.689H37.2402L37.2402 148.966Z",
    fill: " "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 144.828V146.896H51.7232V140.689H49.6554V142.76H47.5875V144.828H49.6554Z",
    fill: " "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 144.828H12.4152V146.896H14.483V144.828Z",
    fill: " "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 144.828V140.689H20.6893V144.828H16.5509V146.896H26.8955V144.828H22.7598Z",
    fill: " "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 144.828H45.517L45.517 146.896H43.4491V148.966H45.517V151.034H43.4491V153.104H41.3786V151.034H39.3107V155.172H37.2402V157.24H35.1723V159.311H39.3107V161.379H41.3786V159.311H43.4491V157.24H41.3786V155.172H45.517V153.104H47.5875V148.966H49.6554V146.896L47.5875 146.896V144.828Z",
    fill: " "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 144.828H53.7938V146.896H55.8616V144.828Z",
    fill: " "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122.068H57.9321V124.138H62.0679V120H60V122.068Z",
    fill: " "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2768 122.068V120H66.2063V124.138H70.3446V122.068H68.2768Z",
    fill: " "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4125 124.138H70.3446V126.206H72.4125V124.138Z",
    fill: " "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M74.483 126.206H72.4152V128.274H74.483V126.206Z",
    fill: " "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2063 128.277V126.206H64.1384V128.277H60V126.206H57.9321V130.345H64.1384V132.415H62.0679V136.551H64.1384V134.483H70.3446V132.412H68.2768V130.345H72.4152V128.277H66.2063Z",
    fill: " "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 148.966H18.6214V151.034H16.5509V153.104H20.6893V148.966Z",
    fill: " "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8277 148.966H22.7598V153.104H24.8277V148.966Z",
    fill: " "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4464 148.966H41.3786V151.034L43.4464 151.034V148.966Z",
    fill: " "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13839 148.966H6.20625V153.104H8.27679V151.034H16.5509V148.966H12.4152L12.4152 146.896H6.20625V144.828H4.13839V146.896H0V148.966H2.06786V153.104H4.13839V148.966Z",
    fill: " "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 153.104H51.7232V155.172H53.7938V148.966H49.6554V153.104Z",
    fill: " "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9295 151.034H55.8616V153.102H57.9295V151.034Z",
    fill: " "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06786 153.104H0V155.172H2.06786L2.06786 153.104Z",
    fill: " "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3446 153.104H8.27679V155.172H10.3446V153.104Z",
    fill: " "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 153.104H12.4152V155.172H14.483V153.104Z",
    fill: " "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 157.24H22.7598V153.104H20.6893V157.24Z",
    fill: " "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6554 153.104H47.5875V155.172H49.6554V153.104Z",
    fill: " "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 155.172H45.517V157.24H47.5848V155.172Z",
    fill: " "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 157.24L6.20625 153.104H4.13839L4.13839 155.172H2.06786V157.24H0V161.379H2.06786V159.311H10.3446V157.24H6.20625Z",
    fill: " "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6214 157.24H16.5509V155.172L14.483 155.172V157.24H12.4152V159.311H16.5509V161.379H18.6214V157.24Z",
    fill: " "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7232 159.311V157.24H47.5875V159.311H51.7232Z",
    fill: " "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4125 159.311H10.3446V161.379H12.4125V159.311Z",
    fill: " "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9661 155.172L26.8955 155.172V153.104L24.8277 153.104V157.24H26.8955V163.449H28.9661V155.172Z",
    fill: " "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 161.379V163.449H53.7938V165.517H57.9321V163.449H60V161.379H57.9321V159.311H51.7232V161.379H55.8616Z",
    fill: " "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20625 161.379H4.13839V163.446H6.20625V161.379Z",
    fill: " "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 161.379H12.4152V163.446H14.483V161.379Z",
    fill: " "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7598 163.449V161.379H24.8277V159.311H20.6893V161.379L18.6214 161.379V163.449H22.7598Z",
    fill: " "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 163.449H16.5509V165.517H18.6188V163.449Z",
    fill: " "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M0 165.517V180H14.483V165.517H0ZM12.4152 169.655V177.932H2.06786V167.587H12.4125V169.655H12.4152Z",
    fill: " "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 165.517H18.6214V167.585H20.6893V165.517Z",
    fill: " "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5848 165.517H45.517V167.585H47.5848V165.517Z",
    fill: " "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M60 165.517L57.9321 165.517V167.585H60V165.517Z",
    fill: " "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6188 167.587H16.5509V169.655H18.6188V167.587Z",
    fill: " "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9634 167.587H26.8955V169.655H28.9634V167.587Z",
    fill: " "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 169.655H53.7938V165.517L51.7259 165.517V161.379H41.3813V167.585H37.2429V165.517H39.3134V163.449H37.2429V161.381H31.0366V163.449H28.9688V167.587H31.0366V165.52H35.175V169.658H37.2429V173.796H39.3134V171.729H49.658V173.796H53.7964V171.729H60.0027V169.661H57.9348V167.593H55.867V169.661L55.8616 169.655ZM49.6554 169.655H43.4491V163.449H49.6554V169.655Z",
    fill: " "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13839 169.655V175.862H10.3446V169.655H4.13839Z",
    fill: " "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 171.723V173.794H35.1723V171.723H33.1045V169.655H28.9661V171.723H31.0339Z",
    fill: " "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8277 173.794H26.8955V171.723H24.8277V167.587H26.8955V163.449H24.8277V165.517H22.7598V167.587H20.6893V171.723H18.6214V173.794H20.6893V177.932H24.8277V180H26.8955V175.862H24.8277V173.794Z",
    fill: " "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5875 175.862H45.517V173.794H41.3786V175.862H43.4491V180H45.517V177.932H51.7232V175.862H49.6554V173.794H47.5875V175.862Z",
    fill: " "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0339 175.862L31.0339 173.794L26.8955 173.794V175.862L28.9661 175.862V180H31.0339V177.932H35.1723V175.862H31.0339Z",
    fill: " "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2402 175.862V177.932L35.1723 177.932V180H41.3786V175.862L37.2402 175.862Z",
    fill: " "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M60 177.932V175.862H55.8616V177.932H60Z",
    fill: " "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2062 161.379H64.1384V165.517H66.2062V161.379Z",
    fill: " "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2062 173.794H62.0679V175.862H64.1384V177.932H62.0679V180H66.2062V173.794Z",
    fill: " "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6893 177.932H18.6214V180H20.6893V177.932Z",
    fill: " "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8616 180L55.8616 177.932L51.7232 177.932V180H55.8616Z",
    fill: " "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrDefault);
export default __webpack_public_path__ + "static/media/qr_default.88287fd579d82f686f2f996dd6dcc718.svg";
export { ForwardRef as ReactComponent };